module.exports = __webpack_public_path__ + "60bbe18eeb7503675aea8b39dde193d3.svg";